import BOSFilterMultiselect from 'Components/Generic/BOSMultiselect/BOSFilterMultiselect';
import { useUserListData } from 'Lib/hooks/useUserListData';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const UserMultiselect = ({
  onSelectedUsersUpdate,
  defaultSelectedItems,
  labelText = 'User',
  maxWidth = 180,
  userRoles,
  orgIds,
  excludedIds,
  autofocus = true,
}) => {
  const filteredUserList = useUserListData({
    userRoles,
    orgIds,
    excludedIds,
  });
  const [selectedUsers, setSelectedUsers] = useState(
    defaultSelectedItems || [],
  );

  useEffect(() => {
    onSelectedUsersUpdate && onSelectedUsersUpdate(selectedUsers);
  }, [selectedUsers]);

  const onSelectionChange = (users) => {
    setSelectedUsers(users);
  };

  return (
    <BOSFilterMultiselect
      labelText={labelText}
      listData={filteredUserList}
      labelField={'displayName'}
      onSelectionUpdate={onSelectionChange}
      placeholder='Select User(s)...'
      defaultSelectedItems={defaultSelectedItems}
      maxWidth={maxWidth}
      autofocus={autofocus}
    />
  );
};

UserMultiselect.propTypes = {
  onSelectedUsersUpdate: PropTypes.func,
  defaultSelectedItems: PropTypes.array,
  labelText: PropTypes.string,
  maxWidth: PropTypes.number,
  userRoles: PropTypes.array,
  orgIds: PropTypes.any,
  excludedIds: PropTypes.array,
  autofocus: PropTypes.bool,
};

export default UserMultiselect;
